import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Card, Spinner, Alert } from "react-bootstrap";
import {
  MdPeople,
  MdBusiness,
  MdShoppingCart,
  MdInventory,
} from "react-icons/md";
import { dashboardAPI } from "../services/api"; // adjust the path if needed
import { Link } from "react-router-dom";

const nf = new Intl.NumberFormat("en-IN"); // nicely formats 1234 -> 1,234

const Dashboard = () => {
  const [counts, setCounts] = useState({
    users: 0,
    partners: 0,
    orders: 0,
    sleeves: 0,
  });
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        setLoading(true);
        setErr("");
        const res = await dashboardAPI.getCounts();
        // res = { success, message, data: { partners, orders, users, sleeves } }
        if (mounted) {
          const d = res?.data || {};
          setCounts({
            users: Number(d.users ?? 0),
            partners: Number(d.partners ?? 0),
            orders: Number(d.orders ?? 0),
            sleeves: Number(d.sleeves ?? 0),
          });
        }
      } catch (e) {
        if (mounted)
          setErr(
            e?.response?.data?.message ||
              e?.message ||
              "Failed to load dashboard."
          );
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  const stats = useMemo(
    () => [
      {
        title: "Total Users",
        value: nf.format(counts.users),
        icon: MdPeople,
        color: "#1976d2",
        to: "/users",
      },
      {
        title: "Total Partners",
        value: nf.format(counts.partners),
        icon: MdBusiness,
        color: "#2e7d32",
        to: "/partners",
      },
      {
        title: "Total Orders",
        value: nf.format(counts.orders),
        icon: MdShoppingCart,
        color: "#ed6c02",
        to: "/orders",
      },
      {
        title: "Total Sleeves",
        value: nf.format(counts.sleeves),
        icon: MdInventory,
        color: "#9c27b0",
        to: "/sleeves",
      },
    ],
    [counts]
  );

  return (
    <div className="p-3">
      <h4 className="mb-3">Dashboard</h4>

      {err && (
        <Alert variant="danger" className="mb-3">
          {err}
        </Alert>
      )}

      <Row className="g-3">
        {/* {stats.map((stat, index) => {
          const Icon = stat.icon;
          return (
            <Col xs={12} sm={6} md={3} key={index}>
              <Card className="h-100">
                <Card.Body>
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <div className="text-muted mb-1">{stat.title}</div>
                      <div style={{ fontSize: 24, fontWeight: "bold" }}>
                        {loading ? <Spinner animation="border" size="sm" /> : stat.value}
                      </div>
                    </div>
                    <div style={{ backgroundColor: stat.color, borderRadius: "50%", padding: 8, color: "#fff" }}>
                      <Icon size={32} />
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          );
        })} */}
        {stats.map((stat, index) => {
          const Icon = stat.icon;
          return (
            <Col xs={12} sm={6} md={3} key={index}>
              <Link
                to={stat.to}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <Card className="h-100 clickable-card">
                  <Card.Body>
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <div className="text-muted mb-1">{stat.title}</div>
                        <div style={{ fontSize: 24, fontWeight: "bold" }}>
                          {loading ? (
                            <Spinner animation="border" size="sm" />
                          ) : (
                            stat.value
                          )}
                        </div>
                      </div>
                      <div
                        style={{
                          backgroundColor: stat.color,
                          borderRadius: "50%",
                          padding: 8,
                          color: "#fff",
                        }}
                      >
                        <Icon size={32} />
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Link>
            </Col>
          );
        })}
      </Row>

      <Row className="g-3 mt-1">
        <Col xs={12} md={6}>
          <Card style={{ height: 300 }}>
            <Card.Body>
              <h6>Recent Activity</h6>
              <div className="text-muted">No recent activity to display.</div>
            </Card.Body>
          </Card>
        </Col>
        <Col xs={12} md={6}>
          <Card style={{ height: 300 }}>
            <Card.Body>
              <h6>Quick Actions</h6>
              <div className="text-muted">
                Quick actions will be displayed here.
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;
